/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

const NetworkActionType = {
  InitiateConnection: 'InitiateConnection',
  ClearSearch: 'ClearSearch'
};

export default NetworkActionType;